import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Kebab = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path d='M12 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2' fill='currentColor' />
        <path d='M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2' fill='currentColor' />
        <path d='M12 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2' fill='currentColor' />
        <path
          d='M12 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M12 4.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5'
          fill='currentColor'
        />
        <path
          d='M12 10.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5'
          fill='currentColor'
        />
        <path
          d='M12 16.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
